export const isBoardPath = (path: string) => {
  return path && path.indexOf('/b/') === 0;
};
